import {RiDeleteBin5Line} from "react-icons/ri";
import SignatureCanvas from "react-signature-canvas";
import {MdClose} from "react-icons/md";
import {PiSignatureDuotone} from "react-icons/pi";
import {Button} from "@chakra-ui/react";
import {useRef, useState} from "react";
export default function SignatureModal({
  setShowModal,
  signature,
  onSave,
}) {

  const [value, setValue] = useState('');
  
  const sigRef = useRef(null);
  return (
    <div className="flex justify-center items-center [margin-top:0_!important] fixed z-[999] inset-0 bg-black/40">
      <div className="relative p-8 rounded-md bg-white w-[500px] flex justify-center items-center">
        {
          <MdClose
            className="text-black cursor-pointer text-lg absolute right-3 top-3"
            onClick={() => {
              setShowModal(null);
              sigRef.current.clear();
           
            }}
          />
        }
        <div
          className="w-full h-full flex justify-center items-start flex-col"
          
        >
          <div className="relative flex justify-center items-start flex-col shadow-md border h-full w-full my-3 bg-white rounded-md">
            <span className="absolute text-xs -top-[22px] left-3 text-black bg-white px-[2px]">
              <span className="text-[2rem]">
                <PiSignatureDuotone />
              </span>
            </span>
            <span
              className="flex absolute cursor-pointer hover:text-red-600 -top-[15px] right-3 justify-center items-center text-red-500 text-[1.4rem] bg-white"
              onClick={(e) => {
                e.stopPropagation();
                sigRef.current.clear();
                value && setValue("");
              }}
            >
              <RiDeleteBin5Line />
            </span>
            <div className="mx-auto border flex overflow-hidden justify-center w-full">
              <SignatureCanvas
                
                penColor="#111827"
                maxWidth={2.5}
                ref={sigRef}
                onEnd={() =>
                  setValue(sigRef.current.toDataURL("image/png"))
                }
                canvasProps={{height: 150, width: 450}}
              />
            </div>
          </div>
          <Button
            colorScheme="blue"
            mt={2}
            alignSelf="flex-end"
         
            onClick={()=>{
              onSave(value);
              setShowModal(null);
            }}
          
            px={6}
            rounded="md"
          >
            Save Signature
           
          </Button>
        </div>
      </div>
    </div>
  );
}
